import { Outlet, useOutletContext } from 'react-router'
import { Header } from '@/components/commons/header'
import { ButtonLinkLegacy } from '@/components/ui/button-link-legacy'
import { AirbnbIcon } from '@/components/ui/icons'
import { Skeleton } from '@/components/ui/skeleton'
import { useGetPhotoset } from '@/features/photoset/queries/use-get-photoset'
import type { PhotosetURLParams } from '@/features/photoset/types'

export const PhotosetLayout = () => {
	const { urlParams } = useOutletContext<{ urlParams: PhotosetURLParams }>()
	const { data: photoset, isFetching } = useGetPhotoset(
		{ id: urlParams.id },
		{ enabled: false }
	)

	return (
		<div className='grid h-full grid-rows-[auto_1fr] overflow-hidden'>
			<Header
				endSlot={
					isFetching ? (
						<>
							<Skeleton height={30} width={140} />
							<Skeleton height={30} width={140} />
						</>
					) : (
						photoset?.pdp_url && (
							<ButtonLinkLegacy
								target='_blank'
								to={photoset.pdp_url}
								variant='tertiary'
							>
								<AirbnbIcon className='fill-neutral-400' />
								{photoset.name}
							</ButtonLinkLegacy>
						)
					)
				}
			/>

			<div className='flex h-full flex-col overflow-y-auto'>
				<Outlet context={{ urlParams }} />
			</div>
		</div>
	)
}

PhotosetLayout.displayName = 'PhotosetLayout'
